import {Component, OnInit} from '@angular/core';
import {ROUTER_DIRECTIVES} from '@angular/router';
import {EmailService} from './email.service';
import {Email} from "./email";

declare var $: any;
declare var particlesJS: any;
declare var google: any;

@Component({
    selector: 'landing',
    template: require('../../app/landingPage/landingPage.component.html'),
    styles: [require('../../app/landingPage/landingPage.component.css')],
    directives: [ROUTER_DIRECTIVES],

})
export class LandingPageComponent implements OnInit {
    email1: Email;
    active: any;
    ok: boolean;
    error: any;
    guardando: boolean;
    isIE: boolean;
    isEdge: boolean;


    constructor(private emailService: EmailService) {
        // Internet Explorer 6-11
        this.isIE = /*@cc_on!@*/false || !!document['documentMode'];
        // Edge 20+
        this.isEdge = !this.isIE && !!window['StyleMedia'];
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Inicializar
        this.active = true;
        this.email1 = new Email();
        this.guardando = false;
        this.ok = false;
        this.error = null;
        // var json = require("../../app/landingPage/assets/particles.json");
        // console.log(json);
        try {
            setTimeout(() =>
                particlesJS.load('particles-js', "../../img/particles.json", function () {
                    console.log('callback - particles.js config loaded');
                    $(".particles-js-canvas-el").css("position", "absolute");
                    $(".particles-js-canvas-el").css("top", "0px");
                }), 1000);

        } catch (e) {
        }

        $(document).scroll(function () {
            if ($(window).scrollTop() > 10) {
                $("#divP").addClass("is-scroll");
            }
            if ($(window).scrollTop() == 0) {
                $("#divP").removeClass("is-scroll");
            }
            if ($("#funcionamiento").offset() && $(window).scrollTop() > $("#funcionamiento").offset().top - 750) {
                console.log("activo");
                $("#fabrica").addClass("animacion");
                $("#linea").addClass("linea");
                $("#circulo").addClass("circulo");
                $("#linea2").addClass("linea2");
                $("#circulo2").addClass("circulo2");
                $("#linea3").addClass("linea3");
                $("#circulo3").addClass("circulo3");
            }
        });

    }

    animarA(nombre) {
        console.log(nombre);
        $('html,body').animate({
            scrollTop: $("#" + nombre).offset().top
        }, 1000);
    }

    isElementInView(element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }

    animarMenuCelular() {
        if ($("#m-nav").attr('class').indexOf("animacionFondoMenuFin") == -1) {
            $("#m-nav").toggleClass("animacionFondoMenuDFin");
            $("#ul-nav").toggleClass("animacionMenuDFin");

            setTimeout(() => {
                $("#m-nav").toggleClass("animacionFondoMenuFin");
                $("#ul-nav").toggleClass("animacionMenuFin");
            }, 200);
        }
        else {
            $("#m-nav").toggleClass("animacionFondoMenuFin");
            $("#ul-nav").toggleClass("animacionMenuFin");

            setTimeout(() => {
                $("#m-nav").toggleClass("animacionFondoMenuDFin");
                $("#ul-nav").toggleClass("animacionMenuDFin");
            }, 600);
        }
    }

    enviarMail() {
        console.log(this.email1);
        this.guardando = true;
        this.emailService
            .enviar(this.email1)
            .subscribe(
                (data) => {
                    this.ok = true;
                    this.guardando = false;
                    this.email1 = new Email();
                    //Reseteo form1 para eliminar errores
                    this.active = false;
                    setTimeout(() => this.active = true, 0);
                },
                (err) => {
                    this.error = err;
                    this.guardando = false
                }
            )
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/landingPage/landingPage.component.ts